import { webGLHelp } from './webgl';

// Shown when the browser has WebGL switched off: the page still reads fine, but the room is gone.
// App shrinks it to a header pill once the visitor scrolls on, so it never covers a card.
export default function NoWebGL({ onClose, onHide }: { onClose: () => void; onHide?: () => void }) {
  const { browser, steps } = webGLHelp();
  return (
    <aside className="nogl" aria-labelledby="nogl-title">
      <span className="bubble-label">3D room is off</span>
      <h2 id="nogl-title">This page is a 3D room, but WebGL is turned off.</h2>
      <p>You can still read everything. To explore it as intended in {browser}:</p>
      <ol>{steps.map(s => <li key={s}>{s}</li>)}</ol>
      <div className="nogl-actions">
        <button type="button" className="btn btn-solid" onClick={onClose}>Got it</button>
        {onHide && <button type="button" className="btn btn-outline" onClick={onHide}>Hide</button>}
      </div>
    </aside>
  );
}
